import { NavLink } from "react-router-dom";
import BannerImg2 from "../../../Assets/Events/2022/Banner_Images/banner_15.png";
import BannerImg9 from "../../../Assets/Events/2025/Banner_Images/Christmas_Banner_2025.webp";
import BannerImg7 from "../../../Assets/Events/2025/Banner_Images/Diwali_Banner_2025.webp";
import BannerImg6 from "../../../Assets/Events/2025/Banner_Images/Fun_Friday_2025_Banner.webp";
import BannerImg5 from "../../../Assets/Events/2025/Banner_Images/HIDay_25_Banner.webp";
import BannerImg4 from "../../../Assets/Events/2025/Banner_Images/Holi_Banner.webp";
import BannerImg8 from "../../../Assets/Events/2025/Banner_Images/KR_Banner_2025.webp";
import BannerImg1 from "../../../Assets/Events/2025/Banner_Images/Republic_Day_Banner.webp";
import BannerImg3 from "../../../Assets/Events/2025/Banner_Images/Womens_Day_Banner.webp";


const Events2025Banner = [
    {
        id: 1,
        bannerImage: <NavLink to={"/republic-day-2025"} className="href"><img src={BannerImg1} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/republic-day-2025"} className="href">Republic Day #2025</NavLink></h4>
    },
    {
        id: 2,
        bannerImage: <NavLink to={"/fun-friday-2025"} className="href"><img src={BannerImg6} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/fun-friday-2025"} className="href">Fun Friday #2025</NavLink></h4>
    },
    {
        id: 3,
        bannerImage: <NavLink to={"/womens-day-2025"} className="href"><img src={BannerImg3} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/womens-day-2025"} className="href">Women's Day #2025</NavLink></h4>
    },
    {
        id: 4,
        bannerImage: <NavLink to={"/happy-holi-2025"} className="href"><img src={BannerImg4} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/happy-holi-2025"} className="href">Happy Holi #2025</NavLink></h4>
    },
    {
        id: 5,
        bannerImage: <NavLink to={"/happy-independence-day-2025"} className="href"><img src={BannerImg5} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/happy-independence-day-2025"} className="href">Happy Independence Day #2025</NavLink></h4>
    },
    {
        id: 6,
        bannerImage: <NavLink to={"/happy-diwali-2025"} className="href"><img src={BannerImg7} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/happy-diwali-2025"} className="href">Happy Diwali #2025</NavLink></h4>
    },
    {
        id: 7,
        bannerImage: <NavLink to={"/karnataka-rajyotsava-2025"} className="href"><img src={BannerImg8} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/karnataka-rajyotsava-2025"} className="href">Karnataka Rajyotsava #2025</NavLink></h4>
    },
    {
        id: 8,
        bannerImage: <NavLink to={"/christmas-2025"} className="href"><img src={BannerImg9} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/christmas-2025"} className="href">Christmas #2025</NavLink></h4>
    },
    {
        id: 9,
        bannerImage: <NavLink to={"/birthday-celebration-2025"} className="href"><img src={BannerImg2} alt="" className='img-fluid' /></NavLink>,
        bannerPara: <h4><NavLink to={"/birthday-celebration-2025"} className="href">Birthday Celebrations</NavLink></h4>
    }
];

export default Events2025Banner;